import { observable } from 'mobx';

const TRANSLATE_EN_STORE = observable({

    HELLO: "hello it's translate test",
    
});

export {TRANSLATE_EN_STORE};